import { BaseCartridge, RomImage } from './base';

/**
 * Mapper 2 — UxROM (UNROM etc.).
 * 16KB switchable bank at 0x8000-0xBFFF, last 16KB fixed at 0xC000-0xFFFF.
 * Bus conflicts tolerated: writes just select the bank.
 */
export class UxromCartridge extends BaseCartridge {
    private bank = 0;

    constructor(image: RomImage) {
        super(image);
    }

    cpuRead(address: number): number {
        const ram = { value: 0 };
        if (this.readPrgRam(address, ram)) return ram.value;
        if (address >= 0xC000) {
            return this.readPrg16(this.prgRom.length / 0x4000 - 1, address);
        }
        if (address >= 0x8000) {
            return this.readPrg16(this.bank, address);
        }
        return 0;
    }

    cpuWrite(address: number, value: number): void {
        if (this.writePrgRam(address, value)) return;
        if (address >= 0x8000) {
            this.bank = value & 0x0F;
        }
    }

    ppuRead(address: number): number {
        return this.chr[address & (this.chr.length - 1)];
    }

    ppuWrite(address: number, value: number): void {
        if (this.chrIsRam) {
            this.chr[address & (this.chr.length - 1)] = value & 0xFF;
        }
    }
}
